<a class="ga-event" routerLink="/1320-club" data-dest="1320 Club" data-ga_category="Home" data-ga_action="Click" data-ga_label="Tile - 1320 Club" title="1320 Club">
  <div class="cta-content">
    <div class="title">Join the club</div>
    <div class="description">All late model Challengers and Chargers welcome</div>
  </div>
</a>